import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "@/lib/api";
import SeoMeta from "@/components/SeoMeta";
import ListenTranslateBar from "@/components/ListenTranslateBar";
import { ArrowRight, Acorn, CloudSun, Dog, Drop, Flower, Leaf, Mountains } from "@phosphor-icons/react";

const ICONS = { Flower, Dog, CloudSun, Leaf, Acorn, Drop, Mountains };

const INTRO = "Seven permanent hubs — flora, fauna, weather, ecosystems, fungi, water and land — form the knowledge spine of NaturePulse. Each connects trusted reference information with the community's living record of observations.";

export default function CatalogueExplore() {
  const [hubs, setHubs] = useState(null);

  useEffect(() => {
    http.get("/catalogue/hubs").then(({ data }) => setHubs(data.hubs || [])).catch(() => setHubs([]));
  }, []);

  return (
    <main className="min-h-screen pt-32 md:pt-36 pb-24 bg-[color:var(--np-bg,#F5EBDC)] text-[#1B4332]" data-testid="catalogue-explore">
      <SeoMeta
        title="The Global Environmental Catalogue"
        description={INTRO}
        canonical={`${window.location.origin}/explore`}
      />
      <div className="max-w-[1200px] mx-auto px-5 md:px-10">
        <div className="font-mono-tech text-[10px] tracking-[0.28em] uppercase text-[color:var(--np-brand,#B85F2A)] mb-2">/ Explore the living archive</div>
        <h1 className="font-serif-display text-4xl md:text-6xl leading-[1.0] tracking-tight">The Global Environmental<br />Catalogue.</h1>
        <p className="mt-3 max-w-2xl text-[#3A3830] text-sm md:text-base">{INTRO}</p>
        <div className="mt-3"><ListenTranslateBar text={INTRO} testidPrefix="catalogue-tools" /></div>

        {!hubs ? (
          <div className="mt-10 font-mono-tech text-[10px] tracking-[0.3em] uppercase">Loading the catalogue…</div>
        ) : (
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-testid="catalogue-hubs">
            {hubs.map((h) => {
              const Icon = ICONS[h.icon] || Leaf;
              return (
                <Link key={h.slug} to={`/explore/${h.slug}`} data-testid={`catalogue-hub-${h.slug}`}
                  className="group rounded-2xl bg-white border border-black/8 text-[#241209] p-6 shadow-sm hover:-translate-y-1 hover:shadow-xl transition-all flex flex-col min-h-[220px]">
                  <Icon size={34} weight="thin" className="text-[#166534] group-hover:scale-110 transition-transform" />
                  <div className="mt-3 font-serif-display text-2xl leading-tight">{h.label}</div>
                  <p className="mt-1.5 text-[13px] text-[#5B4A38] leading-relaxed flex-1">{h.card_copy}</p>
                  <div className="mt-3 flex items-center justify-between font-mono-tech text-[9px] tracking-[0.2em] uppercase text-[#6B5A44]">
                    <span>{h.entity_count} pages · {h.observation_count} observations</span>
                    <ArrowRight size={12} weight="bold" className="text-[#B85F2A] group-hover:translate-x-0.5 transition-transform" />
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </main>
  );
}
